import { useT } from 'flyt/lib/language/language'
import type { StatesEmptyStateProps } from './StatesEmptyState.types'

/**
 * states-empty-state — the portal's one standard "nothing here" presentation.
 *
 * Centred text on the canvas — no panel, no fill, no border (the theme's
 * design language: content floats, it is not boxed). The generic localized
 * title (`common` / `states.empty.title`) sits above the caller's
 * already-localized description, rendered verbatim. Neither a failure nor a busy
 * state, so no alert/status role and no live region — ordinary content in
 * document order. Stateless: output depends only on the description prop and the
 * active locale.
 */
export function StatesEmptyState({ description, title }: StatesEmptyStateProps) {
  const t = useT('common')
  return (
    <div className="px-6 py-12 text-center whitespace-normal">
      <p className="font-medium text-text">{title ?? t('states.empty.title')}</p>
      <p className="mt-1 text-sm text-text-muted">{description}</p>
    </div>
  )
}
